module.exports = __webpack_public_path__ + "img/css3.6971ddc7.svg";